<template>
  <div class="page_1">
    <div class="con_">
      <a-form
        layout="horizontal"
        class="horizontal_item_"
        :form="form"
        @submit="handleSubmit"
      >
        <a-row>
          <div class="block_">
            <div class="title_">
              <div class="cutleft_">基本配置</div>
              <div class="cutoff_"></div>
            </div>
            <a-col :span="12">
              <a-form-item label="产品名称" :label-col="{ span: 7 }">
                <a-input
                  placeholder="请输入产品名称"
                  class="wid_250"
                  v-decorator="[
                    'name',
                    {
                      rules: required,
                      initialValue: quotationData.quotationInfo.name,
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="产品代码" :label-col="{ span: 7 }">
                <a-input
                  placeholder="请输入产品代码"
                  class="wid_250"
                  v-decorator="[
                    'code',
                    {
                      rules: required,
                      initialValue: quotationData.quotationInfo.code,
                    },
                  ]"
                />
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="报价书状态" :label-col="{ span: 7 }">
                <a-select
                  class="wid_250"
                  v-decorator="[
                    'status',
                    {
                      rules: selRequired,
                      initialValue: quotationData.quotationInfo.status,
                    },
                  ]"
                  placeholder="请选择状态"
                >
                  <a-select-option value="0">有效</a-select-option>
                  <a-select-option value="1">无效</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="12">
              <a-form-item label="产品描述" :label-col="{ span: 7 }">
                <a-input
                  placeholder="请输入产品描述"
                  class="wid_250"
                  v-decorator="['productDesc', { rules: required,initialValue:quotationData.quotationInfo.productDesc }]"
                />
              </a-form-item>
            </a-col>
            <!-- <a-col :span="16">
              <a-form-item label="产品主图" :label-col="{ span: 5 }">
                <a-upload
                  name="file"
                  list-type="picture-card"
                  class="avatar-uploader"
                  action="/api_b/ueditor/fileUpload2"
                  :show-upload-list="false"
                  :before-upload="beforeUploadImg"
                  @change="handleChangeImg"
                >
                  <img
                    style="height: 300px; width: auto"
                    v-if="imageUrlUpload"
                    :src="imageUrlUpload"
                    alt="avatar"
                  />
                  <div v-else>
                    <a-icon :type="imageUploadLoading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">上传</div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-col> -->
            <a-col :span="16">
              <a-form-item label="tab页" :label-col="{ span: 5 }">
                <div :style="{ marginBottom: '16px' }">
                  <a-button @click="toggleBg('showAddTab')">
                    添加新tab
                  </a-button>
                </div>
                <a-tabs
                  v-model="activeKey"
                  hide-add
                  type="editable-card"
                  @edit="onEdit"
                >
                  <a-tab-pane
                    v-for="pane in panes"
                    :key="pane.key"
                    :tab="pane.contentTitle"
                    :closable="pane.closable"
                  >
                    <vue-ueditor-wrap
                      @ready="ueditorReady"
                      @beforeInit="beforeUEditorInit"
                      :config="editorConfig"
                      v-model="pane.modelContent"
                    ></vue-ueditor-wrap>
                  </a-tab-pane>
                </a-tabs>
              </a-form-item>
            </a-col>
          </div>
        </a-row>
      </a-form>
    </div>
    <a-button style="float: right; margin-bottom: 30px" @click="saveWrapConfig"
      >保存基本配置</a-button
    >
    <!-- 添加新tab-->
    <div class="fixbg_" v-show="showAddTab == true">
      <div class="fix_con">
        <p>新增tab</p>
        <a-input placeholder="请输入tab名称" v-model="tabTitle" />
        <div class="btn_list">
          <button @click="addTab">确定</button>
          <button @click="toggleBg('showAddTab')">取消</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import ueditorMixin from "@/mixins/ueditor";
const formItemLayout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
};
export default {
  props: {
    quotationData: {
      type: Object,
      default: ()=> {
        return {
          quotationInfo:{
            name: '',
          },
          labelContents:[]
        };
      },
    },
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: "coordinated" }),
      textContent: "",
      formItemLayout,
      imageUploadLoading: false,
      imageUrlUpload: this.quotationData.quotationInfo.productImg,
      activeKey: 1,
      panes: this.quotationData.labelContents,
      required: [{ required: true, message: "请输入" }],
      selRequired: [{ required: true, message: "请选择" }],
      tabTitle: "",
      showAddTab: false,
    };
  },
  // watch: {
  //   panes:  function (newV,oldV){
  //     console.log(newV,oldV,"panes")
  //   }
  // },
  mixins: [ueditorMixin],
  mounted() {
    console.log(this.panes, "->panes");
    if(this.$route.name == 'edit'){
       this.saveWrapConfig()
    }
  },
  methods: {
    handleSubmit() {},
    handleChangeImg(info) {
      if (info.file.status === "uploading") {
        this.imageUploadLoading = true;
        return;
      }
      if (info.file.status === "done") {
        console.log(info);
        this.imageUploadLoading = false;
        this.imageUrlUpload = info.file.response.url;
      }
    },
    beforeUploadImg(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" || file.type === "image/png";
      if (!isJpgOrPng) {
         this.$notification.warning({message: `只能上传图片类型文件`});
      }
      const isLt2M = file.size / 1024 / 1024 / 1024 / 1024 / 1024 < 5;
      if (!isLt2M) {
        this.$notification.warning({message: `图片必须小于5M`});
      }
      return isJpgOrPng && isLt2M;
    },
    callback(key) {
      console.log(key);
    },
    onEdit(targetKey, action) {
      this[action](targetKey);
    },
    remove(targetKey) {
      let activeKey = this.activeKey;
      let lastIndex;
      this.panes.forEach((pane, i) => {
        if (pane.key === targetKey) {
          lastIndex = i - 1;
        }
      });
      const panes = this.panes.filter((pane) => pane.key !== targetKey);
      if (panes.length && activeKey === targetKey) {
        if (lastIndex >= 0) {
          activeKey = panes[lastIndex].key;
        } else {
          activeKey = panes[0].key;
        }
      }
      this.panes = panes;
      this.activeKey = activeKey;
    },
    addTab() {
      if (!this.tabTitle) {
        this.$notification.warning({message: `请输入tab名称`});
      } else {
        let panesA = this.panes;
        console.log(panesA,"panesApanesA")
        const activeKey = this.panes.length + 1;
        panesA.push({
          contentTitle: this.tabTitle,
          modelContent: ``,
          key: activeKey,
        });
        this.panes = panesA;
        this.activeKey = activeKey;
        this.toggleBg("showAddTab");
      }
    },
    toggleBg(param) {
      this[param] = !this[param];
      this.tabTitle = ''
    },
    formatPane() {
      console.log(this.panes);
      let arr = [];
      this.panes.map((item) => {
        arr.push({
          modelType: 1, //1一般内容
          contentTitle: item.contentTitle,
          modelContent: item.modelContent,
        });
      });
      return arr;
    },
    saveWrapConfig() {
      console.log(this.panes,"--->")
      let option = {
        quotationInfo: {},
        labelContents: [],
      };

      this.form.validateFields((error, values) => {
        if (!error) {
          console.log(values);
          option.quotationInfo = {
            ...values,
            productImg: this.imageUrlUpload,
          };
          option.labelContents = this.formatPane();
        } else {
          console.log(error, "error");
          this.$notification.warning({message: `请输入必填项`});
        }
      });
      this.$emit("change", option);
    },
  },
};
</script>

<style lang="scss" scoped>
.page_1 {
  .con_ {
    .title_ {
      margin: 30px 0 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .cutleft_ {
        font-size: 16px;
        font-family: Microsoft YaHei UI;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        // width: 10%;
      }
      .cutoff_ {
        // width:90%;
        flex: 1;
        height: 5px;
        background: #f0f0f0;
      }
    }
    .item_risk {
      width: 50%;
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
    }
  }
}
.title_ {
  display: flex;
  span {
    &:first-child {
      font-weight: bold;
      font-size: 15px;
    }
  }
}
.fixbg_ {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99999;
  .fix_con {
    position: absolute;
    width: 500px;
    background-color: #fff;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 20px;
    top: 25%;
    transform: translateY(-25%);
    > P {
      font-weight: bold;
      text-align: center;
    }
    .btn_list {
      display: flex;
      justify-content: center;
      margin-top: 20px;
      button {
        background-color: #007aff;
        color: #fff;
        text-align: center;
        border: none;
        padding: 5px 20px;
        border-radius: 5px;
        &:last-child {
          margin-left: 30px;
        }
      }
    }
  }
}
.item_cost {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  .flex_input {
    width: 47%;
  }
}
.item_plan {
  border-bottom: 1px solid #ccc;

  .title_ {
    display: flex;
    justify-content: space-between;
  }
  .bold {
    font-weight: bold;
  }
  .item_ {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    span {
      white-space: nowrap;
      margin-right: 20px;
    }
  }
}
.wid_250 {
  width: 250px;
}
</style>
